import { CurrencyLoader } from './CurrencyLoader';

export const currencyLoader: { (token?: string): CurrencyLoader } = (token) =>
  new CurrencyLoader(token);
